import { twMerge } from "@/lib/twMerge";

/** The app's "G" tile (as in the top bar) with a ring circling it, and what's loading beneath.
 * Announced as a status for screen readers; the ring holds still for anyone who's asked for
 * reduced motion, and the tile breathes gently instead. */
export function LoadingLogo({ label, className }: { label: string; className?: string }) {
  return (
    <div role="status" className={twMerge("flex flex-col items-center gap-4 py-16", className)}>
      <div className="relative grid h-16 w-16 place-items-center">
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full border-[3px] border-g-orange/25 border-t-g-orange motion-safe:animate-spin"
        />
        <span
          aria-hidden="true"
          className="grid h-9 w-9 place-items-center rounded bg-g-orange font-[family-name:--font-display] text-lg text-g-off-black motion-reduce:animate-pulse"
        >
          G
        </span>
      </div>
      <p className="text-sm text-text/60">{label}</p>
    </div>
  );
}
